// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table_tableWrapper__FQyjt","table":"Table_table__D9HVU","thWrapper":"Table_thWrapper__0zIFk","tableSize":"Table_tableSize__xGsIJ"};